import React from "react";
import { PropTypes } from "prop-types";



const Button3 = ({
  color,
  onClick,
  formdisable,
  disabled,
  width,
  height,
  word,
  type,
  isBtnEnabled,
  fontSize,
  top
}) => {
 
  return (
    <button
      disabled={disabled || formdisable}
      onClick={onClick}
      style={{
        color: `${color}`,
        height: `${height}`,
        width: `${width}`,
        marginBottom: "1rem",
        marginTop: `${top}rem`,
        display: "flex",
        alignItems: "center",    
        justifyContent: "center", 
        gap: "8px",
        fontSize: `${fontSize}em`,               
      }}
      className="button-app-proceed"
      type={type}
    >
      <span>{word}</span> 
    </button>
  );
};

Button3.propTypes = {
  color: PropTypes.string,
  onClick: PropTypes.func,
  formdisable: PropTypes.func,
  disabled: PropTypes.bool,
  width: PropTypes.string,
  height: PropTypes.string,
  word: PropTypes.string,
  type: PropTypes.string
}

export default Button3;
